import React, { Component } from 'react';
import { query, repository, subscribe } from '@trlogic/client-js';
import { InstanceContainer } from '../../../../config/binding/InstanceBinding';
import Injectables from '../../../../constant/Injectables';
import QueryableRepository = repository.QueryableRepository;
import { MLOpsMetricResult, MLOpsModelResult, MLOpsModelResultFeature } from '../../../../domain/mlops/MLOpsDomains';
import CollectionNames from '../../../../constant/CollectionNames';
import { RootState } from '../../../../redux/store';
import { AiModelState } from '../../../../redux/reducers/AiModelReducer';
import { connect, ConnectedProps } from 'react-redux';
import QueryBuilder = query.QueryBuilder;
import and = query.and;
import eq = query.eq;
import CustomTable, { CustomColumnProps } from '../../../custom/CustomTable';
import FormicaLabel from '../../../custom/FormicaLabel';
import CustomTableContentWrapper from '../../../custom/CustomTableContentWrapper';

class MLOpsFutureImportanceTable extends Component<Props, State> {
  public state: State = new State();
  private mlopsResultSubscription: subscribe.Subscription | undefined;
  private computation: subscribe.Computation | undefined;

  private readonly repository: QueryableRepository = InstanceContainer.get(Injectables.REPOSITORY);

  render() {
    return (
      <div className={''}>
        <FormicaLabel label={'Feature Importances'} />
        <CustomTable columns={this.getColumns()} value={this.state.results?.featureImportances || []} />
      </div>
    );
  }

  public componentDidMount() {
    this.startTracker();
  }

  public componentWillUnmount() {
    this.stopTracker();
  }

  private startTracker = () => {
    const {
      aiModel: { aiModel, isUpdate },
    } = this.props;
    if (!isUpdate) {
      this.setState({ loading: false });
      return;
    }
    const query = QueryBuilder.select()
      .from(CollectionNames.AI_RESULTS)
      .where(and(eq('name', aiModel.name), eq('version', aiModel.version)))
      .build();
    this.mlopsResultSubscription = subscribe.Formica.subscribe(CollectionNames.AI_RESULTS, query);
    this.computation = subscribe.Tracker.autorun(this.tracker, [this.mlopsResultSubscription]);
  };

  private stopTracker = () => {
    this.mlopsResultSubscription?.ready();
    this.computation?.stop();
  };

  private tracker = () => {
    if (this.mlopsResultSubscription?.ready()) {
      this.buildData();
    }
  };

  private buildData = async () => {
    const {
      aiModel: { aiModel },
    } = this.props;
    const query = QueryBuilder.select()
      .from(CollectionNames.AI_RESULTS)
      .where(and(eq('name', aiModel.name), eq('version', aiModel.version)))
      .build();
    const results: MLOpsModelResult | undefined = await this.repository.find(query);

    this.setState({ results, loading: false });
  };

  private getColumns = (): CustomColumnProps[] => {
    return [
      {
        field: 'feature',
        header: 'Variable',
        className: 'w-1/4',
        body: (value: MLOpsModelResultFeature) => {
          return <CustomTableContentWrapper text={value.feature.toString()} />;
        },
      },
      {
        field: 'scaledImportance',
        header: 'Scaled Importance',
        className: 'w-1/6',
        body: (value: MLOpsModelResultFeature) => {
          return <CustomTableContentWrapper text={value.scaledImportance.toString()} />;
        },
      },
      {
        field: 'relativeImportance',
        header: 'Relative Importance',
        className: 'w-1/4',
        body: (value: MLOpsModelResultFeature) => {
          return <CustomTableContentWrapper text={value.relativeImportance.toString()} />;
        },
      },
      {
        field: 'percentage',
        header: 'Percentage',
        className: 'w-1/4',
        body: (value: MLOpsModelResultFeature) => {
          return <CustomTableContentWrapper text={value.percentage.toString()} />;
        },
      },
    ];
  };
}

class State {
  results: MLOpsModelResult | undefined;
  loading: boolean = true;
}

interface Props extends ReduxProps {}

const mapStateToProps = (state: RootState) => ({
  aiModel: state.aiModel as AiModelState,
});
const mapDispatchToProps = {};
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(MLOpsFutureImportanceTable);
